import http from './httpService'

/*** Get list of orders from shopify based on query ***/
export function getOrdersShopify(paged, store, query, limit) {
  limit = limit || 50

  let url = `/shopify/orders?limit=${limit}&store=${store}`

  if (paged && paged !== 'current') url += `&page_info=${paged}`

  if (query) url += `&query=${query}`

  return http.get(url)
}

/*** Get list of mizodia orders from shopify based on query ***/
export function getMizodiaOrdersShopify(paged, store, query, limit) {
  limit = limit || 50

  let url = `/shopify/mizodia-orders?limit=${limit}&store=${store}`

  if (paged && paged !== 'current') url += `&page_info=${paged}`

  if (query) url += `&query=${query}`

  return http.get(url)
}

/*** Renew order from shopify ***/
export function renewRegistryShopify(orderId, store) {
  if (!orderId) return console.log('orderId is undefined')

  return http.post(`/registries/renew`, { orderId, store })
}

/*** Count number of orders based on status ***/
export function countOrdersShopify(store, status) {
  return http.get(`/shopify/orders/count?store=${store}&status=${status}`)
}


export function fulfillOrderShopify(order) {
  return http.put(`/shopify/fulfill/${order.orderId}`, order)
}
